<!-- Toolbar -->
<div class="toolbar" role="banner">
  <!-- Home Start-->
  <section class="home-section" id="home">
    <div class="home-bg">
      <div
        class="welcome-text text-center"
        i18n
        [innerHTML]="'enliiigne.DontWaitInLine' | translate"
      ></div>
      <video
        width="100%"
        preload="true"
        autoplay="true"
        id="vid"
        oncanplay="this.play()"
        onloadedmetadata="this.muted = true"
        loop="true"
        class="header-video"
      >
        <source src="assets/video/intro.mov" type="video/mp4" />
        <source src="assets/video/intro.gov" type="video/gov" />
        <source src="assets/video/intro.webm" type="video/webm" />
      </video>
      <div class="welcome-text-area">
        <div class="welcome-area">
          <div class="container">
            <div class="row">
              <div class="col-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="#aboutus" class="scroll-next"
      ><img src="assets/images/down-arrow.png" class="img-fluid" alt=""
    /></a>
  </section>
  <!-- Home End -->

  <section class="section" id="howitworks">
    <div class="container">
      <div class="title-block mx-auto">
        <div class="section_title mb-4 text-center">
          <h2>
            <span i18n [innerHTML]="'enliiigne.AppFeatures' | translate"></span>
          </h2>
          <span
            class="scroll-title"
            data-enllax-ratio="2.5"
            data-enllax-type="foreground"
            data-enllax-direction="horizontal"
            [innerHTML]="'enliiigne.AppFeaturesShadowText' | translate"
          ></span>
        </div>
      </div>
      <div class="work-steps-process">
        <div class="work-steps-box">
          <div class="row align-items-center">
            <div class="col-md-6 col-sm-12">
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_1_title_1' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_1_description_1' | translate
                    "
                  ></p>
                </div>
              </div>
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_1_title_2' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_1_description_2' | translate
                    "
                  ></p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="work-steps-images"
                [innerHTML]="'enliiigne.appFeatures_1_img' | translate"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="work-steps-process">
        <div class="work-steps-box">
          <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6 col-sm-12">
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_2_title_1' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_2_description_1' | translate
                    "
                  ></p>
                </div>
              </div>
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_2_title_2' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_2_description_2' | translate
                    "
                  ></p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="work-steps-images"
                [innerHTML]="'enliiigne.appFeatures_2_img' | translate"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="work-steps-process">
        <div class="work-steps-box">
          <div class="row align-items-center">
            <div class="col-md-6 col-sm-12">
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_3_title_1' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_3_description_1' | translate
                    "
                  ></p>
                </div>
              </div>
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_3_title_2' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_3_description_2' | translate
                    "
                  ></p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="work-steps-images"
                [innerHTML]="'enliiigne.appFeatures_3_img' | translate"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="work-steps-process">
        <div class="work-steps-box">
          <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6 col-sm-12">
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_4_title_1' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_4_description_1' | translate
                    "
                  ></p>
                </div>
              </div>
              <div class="work-steps-detail d-flex align-items-start">
                <div class="steps-icon">
                  <i class="mdi mdi-file-document-edit-outline"></i>
                </div>
                <div class="steps-text">
                  <h4
                    i18n
                    [innerHTML]="'enliiigne.appFeatures_4_title_2' | translate"
                  ></h4>
                  <p
                    class="step-desc"
                    i18n
                    [innerHTML]="
                      'enliiigne.appFeatures_4_description_2' | translate
                    "
                  ></p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="work-steps-images"
                [innerHTML]="'enliiigne.appFeatures_4_img' | translate"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Start About Countdown Area-->
  <section class="parallax parallax-box section">
    <div id="counter">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-6">
            <div class="sponsors-logo">
              <img src="assets/images/features/desjardins.png" alt="" />
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="sponsors-logo">
              <img src="assets/images/features/google.png" alt="" />
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="sponsors-logo">
              <img
                src="assets/images/features/bonjour-startup-montreal.png"
                alt=""
              />
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="sponsors-logo">
              <img src="assets/images/features/post-covid.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- End About Countdown Area-->

  <!-- Start About-Us -->
  <section class="section" id="aboutus">
    <div class="container">
      <div class="title-block mx-auto">
        <div class="section_title mb-4 text-center">
          <h2>
            <span i18n [innerHTML]="'enliiigne.AboutUs' | translate"></span>
          </h2>
          <span
            class="scroll-title"
            data-enllax-ratio="2.5"
            data-enllax-type="foreground"
            data-enllax-direction="horizontal"
            i18n
            [innerHTML]="'enliiigne.AboutUsShadowText' | translate"
          ></span>
        </div>
      </div>
      <div class="title-block mx-auto">
        <div class="section_title mb-4 text-center">
          <div class="image-container">
            <a class="clickable" href="https://post-covid.ca/"
              ><h3
                i18n
                [innerHTML]="'enliiigne.WinnersOfPostCovid' | translate"
              ></h3
            ></a>
            <div
              class="text"
              i18n
              [innerHTML]="
                'enliiigne.WinnersOfPostCovidDescription' | translate
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6 col-sm-12 order-md-2">
          <div class="about-image-block">
            <img
              src="assets/images/aboutus/team.jpg"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
        <div class="col-md-6 col-sm-12 order-md-1">
          <div class="about-text-block">
            <div class="about-content">
              <h4
                i18n
                [innerHTML]="'enliiigne.AboutOurTeamTitle' | translate"
              ></h4>
              <div
                class="text"
                i18n
                [innerHTML]="'enliiigne.AboutOurTeamDescription' | translate"
              >
                <br />
                <br /><strong
                  >Alexandre Ratthé, Brian McWilliams, Mariya Zinchenko</strong
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End About-Us -->
</div>
